export const TipoPerfil = {

  MASTER: { id: 1, nome: 'Master Jaleko', ordem: 6 },
  ADMIN: { id: 2, nome: 'Admin Master', ordem: 5 },
  ADMIN_RESTRITO: { id: 6, nome: 'Admin', ordem: 4 },
  PROFESSOR: { id: 4, nome: 'Professor', ordem: 3 },
  ALUNO: { id: 5, nome: 'Aluno', ordem: 1 },
  ANALISTA: { id: 7, nome: 'Analista', ordem: 2 },
  MASTER_JALEKO: { id: 8, nome: 'Analista', ordem: 7 }
}

const isTipoPerfil = (perfilId, tipoPerfil) => {
  return tipoPerfil.id === perfilId
}

export const TipoPerfilUtil = {
  obterPorId: id => {
    const key = Object.keys(TipoPerfil).find(item => TipoPerfil[item].id === id)
    if (key) {
      return TipoPerfil[key]
    }
    return {}
  },

  listar: () => Object.keys(TipoPerfil).map(key => TipoPerfil[key]),

  listarPorPerfil: (perfil) => {
    const perfis = Object.keys(TipoPerfil).map(key => TipoPerfil[key])
    if (TipoPerfil.MASTER.id === perfil) {
      return perfis
    } else if (TipoPerfil.ADMIN.id === perfil) {
      return perfis.filter(item => item.id > perfil)
    } else {
      return []
    }
  },

  isMaster: perfilId => isTipoPerfil(perfilId, TipoPerfil.MASTER),

  isAdmin: perfilId => isTipoPerfil(perfilId, TipoPerfil.ADMIN),

  isAdminRestrito: perfilId => isTipoPerfil(perfilId, TipoPerfil.ADMIN_RESTRITO),

  isProfessor: perfilId => isTipoPerfil(perfilId, TipoPerfil.PROFESSOR),

  isAnalista: perfilId => isTipoPerfil(perfilId, TipoPerfil.ANALISTA),

  isAluno: perfilId => isTipoPerfil(perfilId, TipoPerfil.ALUNO),

  isMasterJaleko: perfilId => isTipoPerfil(perfilId, TipoPerfil.MASTER_JALEKO),

  isTipoPerfil: isTipoPerfil

}

export default TipoPerfil
